import { render, staticRenderFns } from "./ChangePhoneDia.vue?vue&type=template&id=324ae0c7&scoped=true"
import script from "./ChangePhoneDia.vue?vue&type=script&lang=js"
export * from "./ChangePhoneDia.vue?vue&type=script&lang=js"
import style0 from "./ChangePhoneDia.vue?vue&type=style&index=0&id=324ae0c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "324ae0c7",
  null
  
)

export default component.exports